module.exports = __webpack_public_path__ + "static/media/shutterstock_172135856_0006_007.fa980371.png";